export const LOTTERY_MY_TICKETS_TABS = 'LOTTERY_MY_TICKETS_TABS';

export const LOTTERY_AVAILABLE_TABS_REQUEST = 'LOTTERY_AVAILABLE_TABS_REQUEST';
export const LOTTERY_AVAILABLE_TABS_SUCCESS = 'LOTTERY_AVAILABLE_TABS_SUCCESS';
export const LOTTERY_AVAILABLE_TABS_FAILURE = 'LOTTERY_AVAILABLE_TABS_FAILURE';

export const LOTTERY_PAGE_DATA_REQUEST = 'LOTTERY_PAGE_DATA_REQUEST';
export const LOTTERY_PAGE_DATA_SUCCESS = 'LOTTERY_PAGE_DATA_SUCCESS';
export const LOTTERY_PAGE_DATA_FAILURE = 'LOTTERY_PAGE_DATA_FAILURE';

export const LOTTERY_PRIZE_DATA_REQUEST = 'LOTTERY_PRIZE_DATA_REQUEST';
export const LOTTERY_PRIZE_DATA_SUCCESS = 'LOTTERY_PRIZE_DATA_SUCCESS';
export const LOTTERY_PRIZE_DATA_FAILURE = 'LOTTERY_PRIZE_DATA_FAILURE';

export const GET_LOTTERY_MY_TICKET_LIST_REQUEST = 'GET_LOTTERY_MY_TICKET_LIST_REQUEST';
export const GET_LOTTERY_MY_TICKET_LIST_SUCCESS = 'GET_LOTTERY_MY_TICKET_LIST_SUCCESS';
export const GET_LOTTERY_MY_TICKET_LIST_FAILURE = 'GET_LOTTERY_MY_TICKET_LIST_FAILURE';
export const GET_LOTTERY_MY_TICKET_LIST_RESET = 'GET_LOTTERY_MY_TICKET_LIST_RESET';

export const GET_LOTTERY_MY_TICKET_DETAIL_REQUEST = 'GET_LOTTERY_MY_TICKET_DETAIL_REQUEST';
export const GET_LOTTERY_MY_TICKET_DETAIL_SUCCESS = 'GET_LOTTERY_MY_TICKET_DETAIL_SUCCESS';
export const GET_LOTTERY_MY_TICKET_DETAIL_FAILURE = 'GET_LOTTERY_MY_TICKET_DETAIL_FAILURE';
export const GET_LOTTERY_MY_TICKET_DETAIL_RESET = 'GET_LOTTERY_MY_TICKET_DETAIL_RESET';

export const LOTTERY_SERIAL_DATA_REQUEST = 'LOTTERY_SERIAL_DATA_REQUEST';
export const LOTTERY_SERIAL_DATA_SUCCESS = 'LOTTERY_SERIAL_DATA_SUCCESS';
export const LOTTERY_SERIAL_DATA_FAILURE = 'LOTTERY_SERIAL_DATA_FAILURE';

export const LOTTERY_SPECIAL_DATA_REQUEST = 'LOTTERY_SPECIAL_DATA_REQUEST';
export const LOTTERY_SPECIAL_DATA_SUCCESS = 'LOTTERY_SPECIAL_DATA_SUCCESS';
export const LOTTERY_SPECIAL_DATA_FAILURE = 'LOTTERY_SPECIAL_DATA_FAILURE';
export const LOTTERY_SPECIAL_DATA_RESET = 'LOTTERY_SPECIAL_DATA_RESET';

export const GET_LOTTERY_DRAWS_REQUEST = 'GET_LOTTERY_DRAWS_REQUEST';
export const GET_LOTTERY_DRAWS_SUCCESS = 'GET_LOTTERY_DRAWS_SUCCESS';
export const GET_LOTTERY_DRAWS_FAILURE = 'GET_LOTTERY_DRAWS_FAILURE';

export const GET_LOTTERY_DRAW_ACTIVE_REQUEST = 'GET_LOTTERY_DRAW_ACTIVE_REQUEST';
export const GET_LOTTERY_DRAW_ACTIVE_SUCCESS = 'GET_LOTTERY_DRAW_ACTIVE_SUCCESS';
export const GET_LOTTERY_DRAW_ACTIVE_FAILURE = 'GET_LOTTERY_DRAW_ACTIVE_FAILURE';

export const LOTTERY_ONE_OF_SERIAL_REQUEST = 'LOTTERY_ONE_OF_SERIAL_REQUEST';
export const LOTTERY_ONE_OF_SERIAL_SUCCESS = 'LOTTERY_ONE_OF_SERIAL_SUCCESS';
export const LOTTERY_ONE_OF_SERIAL_FAILURE = 'LOTTERY_ONE_OF_SERIAL_FAILURE';

export const GET_LOTTERY_QUERY_RESULT_REQUEST = 'GET_LOTTERY_QUERY_RESULT_REQUEST';
export const GET_LOTTERY_QUERY_RESULT_SUCCESS = 'GET_LOTTERY_QUERY_RESULT_SUCCESS';
export const GET_LOTTERY_QUERY_RESULT_FAILURE = 'GET_LOTTERY_QUERY_RESULT_FAILURE';
export const GET_LOTTERY_QUERY_RESULT_RESET = 'GET_LOTTERY_QUERY_RESULT_RESET';

export const TOGGLE_TICKET_TO_LOTTERY_SLIP = 'TOGGLE_TICKET_TO_LOTTERY_SLIP';
export const TOGGLE_TICKET_TO_SUPER_LOTTERY_SLIP = 'TOGGLE_TICKET_TO_SUPER_LOTTERY_SLIP';
export const CLEAR_LOTTERY_SLIP = 'CLEAR_LOTTERY_SLIP';
export const CLEAR_SUPER_LOTTERY_SLIP = 'CLEAR_SUPER_LOTTERY_SLIP';
export const SET_LOTTERYSLIP_FROM_LOCAL_STORAGE = 'SET_LOTTERYSLIP_FROM_LOCAL_STORAGE';
export const SET_SUPER_LOTTERYSLIP_FROM_LOCAL_STORAGE = 'SET_SUPER_LOTTERYSLIP_FROM_LOCAL_STORAGE';
export const ACCEPT_LOTTERY_CONTRACT = 'ACCEPT_LOTTERY_CONTRACT';

export const LOTTERY_BUY_TICKETS_REQUEST = 'LOTTERY_BUY_TICKETS_REQUEST';
export const LOTTERY_BUY_TICKETS_SUCCESS = 'LOTTERY_BUY_TICKETS_SUCCESS';
export const LOTTERY_BUY_TICKETS_FAILURE = 'LOTTERY_BUY_TICKETS_FAILURE';
export const LOTTERY_BUY_TICKETS_RESET = 'LOTTERY_BUY_TICKETS_RESET';

export const LOTTERY_SHARED_TICKET_LIST_REQUEST = 'LOTTERY_SHARED_TICKET_LIST_REQUEST';
export const LOTTERY_SHARED_TICKET_LIST_SUCCESS = 'LOTTERY_SHARED_TICKET_LIST_SUCCESS';
export const LOTTERY_SHARED_TICKET_LIST_FAILURE = 'LOTTERY_SHARED_TICKET_LIST_FAILURE';

export const LOTTERY_SHARED_TICKET_LIST_RESET = 'LOTTERY_SHARED_TICKET_LIST_RESET';

export const LOTTERY_SHARED_TICKET_DETAIL_REQUEST = 'LOTTERY_SHARED_TICKET_DETAIL_REQUEST';
export const LOTTERY_SHARED_TICKET_DETAIL_SUCCESS = 'LOTTERY_SHARED_TICKET_DETAIL_SUCCESS';
export const LOTTERY_SHARED_TICKET_DETAIL_FAILURE = 'LOTTERY_SHARED_TICKET_DETAIL_FAILURE';
export const LOTTERY_SHARED_TICKET_DETAIL_RESET = 'LOTTERY_SHARED_TICKET_DETAIL_RESET';

export const LOTTERY_SHARED_TICKET_BUY_REQUEST = 'LOTTERY_SHARED_TICKET_BUY_REQUEST';
export const LOTTERY_SHARED_TICKET_BUY_SUCCESS = 'LOTTERY_SHARED_TICKET_BUY_SUCCESS';
export const LOTTERY_SHARED_TICKET_BUY_FAILURE = 'LOTTERY_SHARED_TICKET_BUY_FAILURE';

export const LOTTERY_SET_RENDER_TYPE = 'LOTTERY_SET_RENDER_TYPE';
